import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { ChangeEvent } from "react";

import { Tooltip } from "../tooltip/Tooltip";
import useFieldData from "./useFieldData";
import useFieldName from "./useFieldName";

interface Props {
  fieldData: Record<string, Field<string>>;
  name: string;
  fieldName: string;
  value?: boolean;
  id?: string;
  onChange?: (value: boolean) => void;
}

const SwitchInput = (props: Props) => {
  const { name, fieldName } = useFieldName(props.name, props.fieldName);
  const { heading, tooltip } = useFieldData(props.fieldData, name);

  const onFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
    const fieldValue = e.target.checked;
    if (props.onChange) {
      props.onChange(fieldValue);
    }
  };

  return (
    <div className="form-row">
      <div className="form-option toggle-switch">
        <input
          className="toggle-switch__contact"
          id={props.id || fieldName}
          name={fieldName}
          type="checkbox"
          onChange={onFieldChange}
          checked={props.value === true}
        />
        <label className="toggle-switch__lever" htmlFor={props.id || fieldName}>
          {heading.value}
        </label>
        <Tooltip fieldName={fieldName} value={tooltip.value} />
      </div>
    </div>
  );
};

export default SwitchInput;
